import React from 'react'
import './tooltip.scss'

export default (props) => {
  const classes = `lc_tooltip ${props.className || ''}`

  return (
    <div className={classes}>{props.tooltipSpanText}
      <span className="tooltiptext">{props.tooltipText}</span>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/UI/Tooltip/index.js